let confirmNavigation;

export function registerNavigationConfirmation(confirm) {
  confirmNavigation = confirm;
  return () => { if (confirmNavigation === confirm) confirmNavigation = null; };
}

export function requestNavigationConfirmation(value, callback) {
  if (!confirmNavigation) { callback(false); return; }
  confirmNavigation(value).then(callback, () => callback(false));
}
